var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""}},[_c('div',{class:{hamburger: true, 'hamburger--slider': true, 'is-active': _vm.menuIsOpen},on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"hamburger-box"},[_c('div',{staticClass:"hamburger-inner"})]),(_vm.$vuetify.breakpoint.mdAndUp)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('header.menu.label')))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }